import { FETCH_WRITERS_SUCCESS } from './writers-actions';

const writers = (state: any[] = [], { type, payload }: any = {}): any[] => {
  switch (type) {
    case FETCH_WRITERS_SUCCESS:
      return payload;

    default:
      return state;
  }
};

export default writers;
